var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasino(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9091 55.3636V11.7273H39.7045V55.3636H36.9091ZM46.3182 24.8182C46.1136 23.0909 45.2841 21.75 43.8295 20.7955C42.375 19.8409 40.5909 19.3636 38.4773 19.3636C36.9318 19.3636 35.5795 19.6136 34.4205 20.1136C33.2727 20.6136 32.375 21.3011 31.7273 22.1761C31.0909 23.0511 30.7727 24.0455 30.7727 25.1591C30.7727 26.0909 30.9943 26.892 31.4375 27.5625C31.892 28.2216 32.4716 28.7727 33.1761 29.2159C33.8807 29.6477 34.6193 30.0057 35.392 30.2898C36.1648 30.5625 36.875 30.7841 37.5227 30.9545L41.0682 31.9091C41.9773 32.1477 42.9886 32.4773 44.1023 32.8977C45.2273 33.3182 46.3011 33.892 47.3239 34.6193C48.358 35.3352 49.2102 36.2557 49.8807 37.3807C50.5511 38.5057 50.8864 39.8864 50.8864 41.5227C50.8864 43.4091 50.392 45.1136 49.4034 46.6364C48.4261 48.1591 46.9943 49.3693 45.108 50.267C43.233 51.1648 40.9545 51.6136 38.2727 51.6136C35.7727 51.6136 33.608 51.2102 31.7784 50.4034C29.9602 49.5966 28.5284 48.4716 27.483 47.0284C26.4489 45.5852 25.8636 43.9091 25.7273 42H30.0909C30.2045 43.3182 30.6477 44.4091 31.4205 45.2727C32.2045 46.125 33.1932 46.7614 34.3864 47.1818C35.5909 47.5909 36.8864 47.7955 38.2727 47.7955C39.8864 47.7955 41.3352 47.5341 42.6193 47.0114C43.9034 46.4773 44.9205 45.7386 45.6705 44.7955C46.4205 43.8409 46.7955 42.7273 46.7955 41.4545C46.7955 40.2955 46.4716 39.3523 45.8239 38.625C45.1761 37.8977 44.3239 37.3068 43.267 36.8523C42.2102 36.3977 41.0682 36 39.8409 35.6591L35.5455 34.4318C32.8182 33.6477 30.6591 32.5284 29.0682 31.0739C27.4773 29.6193 26.6818 27.7159 26.6818 25.3636C26.6818 23.4091 27.2102 21.7045 28.267 20.25C29.3352 18.7841 30.767 17.6477 32.5625 16.8409C34.3693 16.0227 36.3864 15.6136 38.6136 15.6136C40.8636 15.6136 42.8636 16.017 44.6136 16.8239C46.3636 17.6193 47.75 18.7102 48.7727 20.0966C49.8068 21.483 50.3523 23.0568 50.4091 24.8182H46.3182Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58_2",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasino);
export default __webpack_public_path__ + "static/media/casino.ffd12366b5af9d60bc0e227bf03becf1.svg";
export { ForwardRef as ReactComponent };